
/**
 * Fetch and combine all social media posts
 * - In production: uses Cloudflare Function (/api/instagram-posts)
 * - In local dev: fetches RSS directly and proxies through CORS
 */
export const fetchSocialFeed = async () => {
  

  // Production mode - use Cloudflare Function
  try {
    console.log('🔧 Fetching social feed from Cloudflare Function...');

    const response = await fetch('/api/instagram-posts');

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP ${response.status}`);
    }

    const data = await response.json();

    console.log(`✅ Loaded ${data.posts?.length || 0} posts from social feed`);

    return {
      success: true,
      posts: data.posts || [],
    };

  } catch (error) {
    console.error('❌ Error fetching social feed:', error);
    return {
      success: false,
      error: error.message,
      posts: [],
    };
  }
};

const socialFeedService = {
  fetchSocialFeed,
};

export default socialFeedService;
